<template>
    <div class="home">
        <PCHome v-if="! isMobile"></PCHome>
        <MobileHome v-if="isMobile"></MobileHome>
    </div>

</template>

<script>
// @ is an alias to /src
import {mapGetters} from 'vuex'
import PCHome from "./home/PCHome"
import MobileHome from "./home/MobileHome";

export default {
  name: 'Home',
  components: {
      MobileHome,
      PCHome
   },
    computed: {
        ...mapGetters(['isMobile'])
    }
}
</script>
<style scoped>
    .home {
        height: 100%;
        width: 100%;
    }
</style>
